import axios from "@/api/axiosAuthRequired.js"

const PROGUIDES_WEB_URL = process.env.PROGUIDES_WEB_URL

export const loadSaleBanner = async () => {
  try {
    const res = await axios.get(`${PROGUIDES_WEB_URL}api/v2/promo-code-banners`)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}



// WEBPACK FOOTER //
// ./src/api/utils.js